<template>
 <div>
   <div class="searchBox" ref="searchBox">
      <el-form :inline="true"  class="demo-form-inline" label-width="110px" size="mini">
         <div class="searchBox inpBox">
            <div class="item">
            <el-form-item label="卡号:" prop="vice_no">
              <el-input  placeholder="" v-model="searchFrom.vice_no"></el-input>
            </el-form-item>
            <el-form-item label="车牌号:" prop="truck_no">
              <el-input  placeholder="" v-model="searchFrom.truck_no"></el-input>
            </el-form-item>
            <el-form-item label="司机姓名:" prop="qz_drivername">
              <el-input  placeholder="" v-model="searchFrom.qz_drivername"></el-input>
            </el-form-item>
            <el-form-item label="油卡类型:" prop="oil_com">
              <el-select size="mini" v-model="searchFrom.oil_com" placeholder="请选择" >
                <el-option
                  v-for="item in oilTypeList"
                  :label="item.oliname"
                  :key="item.value"
                  :value="item.value"
                ></el-option>
              </el-select>
            </el-form-item>
            <el-form-item label="油品类型:" prop="oil_type_name">
                <el-select  v-model="searchFrom.oil_type_name"   placeholder="请选择">
                  <el-option label="汽油" value="1"></el-option>
                  <el-option label="柴油" value="2"></el-option>
                  <el-option label="液化天然气" value="5"></el-option>
                </el-select>
            </el-form-item>
            <!-- <el-form-item label="司机电话:" prop="businessNo">
              <el-input  placeholder="" v-model="searchFrom.businessNo"></el-input>
            </el-form-item> -->
            <!-- <el-form-item label="加油时间:" prop="reportTime">
                <el-date-picker
                  v-model="searchFrom.reportTimes"
                  format="yyyy-MM-dd"
                  value-format="yyyy-MM-dd"
                  type="daterange"
                  range-separator="至"
                  start-placeholder="开始日期"
                  end-placeholder="结束日期"
                ></el-date-picker>
            </el-form-item> -->
             <el-form-item label="交易时间:" prop="trade_time">
             <el-date-picker
                v-model="searchFrom.trade_timeGS"
                format="yyyy-MM-dd"
                value-format="yyyy-MM-dd"
                type="daterange"
                range-separator="至"
                start-placeholder="开始日期"
                end-placeholder="结束日期"
                 :picker-options="pickerOptions"
              ></el-date-picker>
              </el-form-item>
            <!-- <el-form-item label="加油省份:" prop="businessNo">
              <el-input  placeholder="" v-model="searchFrom.businessNo"></el-input>
            </el-form-item> -->
            </div>
          </div>
            <div class="searchBtnBox">
              <el-form-item>
                <el-button type="primary"  @click="searchFn" v-if="btnFlg[0]">查询</el-button>
              </el-form-item>
              <el-form-item>
                <el-button type="primary"  @click="resetForm('searchFrom')">重置</el-button>
              </el-form-item>
              <el-form-item>
                <el-button type="primary"  @click="exportFn"  :disabled="isDisable" v-if="btnFlg[1]">导出</el-button>
              </el-form-item>
              <!-- <el-form-item>
                <p class="margin0">总金额合计：<span class="red">{{AllData.total}}</span>元</p>
              </el-form-item> -->
            </div>
      </el-form>
    </div>
    <!--  表格 -->
    <div class="table" :style="{height:h}">
      <el-table :data="tableList"  ref="table" v-loading="loading"   bordersize="mini"  @selection-change='selectGoods'
       @row-click="handleRowClick"  style="width: 100%" height="100%"  center border>
        <el-table-column type="index" prop="date" width="55" label="序号"></el-table-column>
        <el-table-column prop="trade_time"  min-width="180" :formatter="emptyFn" label="交易时间"></el-table-column>
        <el-table-column prop="vice_no"  min-width="200" :formatter="emptyFn" label="卡号"></el-table-column>
        <el-table-column prop="qz_drivername"  min-width="150" :formatter="emptyFn" label="司机姓名"></el-table-column>
        <el-table-column prop="qz_drivertel"  min-width="150" :formatter="emptyFn" label="司机手机号"></el-table-column>
        <el-table-column prop="truck_no"  min-width="170" :formatter="emptyFn" label="车牌号"></el-table-column>
        <el-table-column prop="oil_type_name"  min-width="120" :formatter="emptyFn" label="油品类型名称"></el-table-column>
        <el-table-column prop="oil_name"  min-width="220" :formatter="emptyFn" label="油品名称"></el-table-column>
        <el-table-column prop="trade_price"  min-width="150" :formatter="emptyFn" label="交易单价"></el-table-column>
        <el-table-column prop="trade_num"  min-width="150" :formatter="emptyFn" label="交易升数"></el-table-column>
        <el-table-column prop="trade_money"  width="150" :formatter="emptyFn" label="消费金额（元）"></el-table-column>
        <el-table-column prop="trade_place"  min-width="190" :formatter="emptyFn" label="交易地点"></el-table-column>
        <el-table-column prop="trade_place_provice_name"  min-width="170" :formatter="emptyFn" label="交易省名称"></el-table-column>
        <el-table-column prop="oil_com"  min-width="160" label="油卡类型">
          <template scope="scope">
            <div>
              {{scope.row.oil_com == '20' ?  'G7能源-充值子账户' : '-'}}
            </div>
          </template>
        </el-table-column>
      </el-table>
    </div>
     <!-- 分页 -->
    <div>
      <el-pagination background
        @size-change="handleSizeChange"
        @current-change="handleCurrentChange"
        :current-page="searchFrom.pageNo"
        :page-sizes="[50,100,200,1000]"
        :page-size="searchFrom.pageSize"
        layout="total, sizes, prev, pager, next, jumper"
        :total="total">
      </el-pagination>
    </div>
 </div>
</template>

<script>
import { getBtn } from '@/utils/getButton'
import { emptyFn, dateTimeFormat, dateFormat, dateFormatUtil } from '@/utils/util'
import { getG7CardExpenseTraderList } from '@/api/consignment'
import { exportExcel } from '@/utils/fileDown.js'
export default {
  data () {
    let _this = this
    return {
      duration: [],
      pickerOptions: {
        disabledDate (time) {
          let currentTime = _this.duration[0]
          let threeMonths = 60 * 60 * 1000 * 24 * 90
          if (currentTime) {
            return time.getTime() > currentTime.getTime() + threeMonths || time.getTime() < currentTime.getTime() - threeMonths
          }
        },
        onPick ({ minDate, maxDate }) {
          if (minDate && !maxDate) {
            _this.duration[0] = minDate
          }
          if (maxDate) {
            _this.duration[1] = maxDate
          }
        }
      },
      oilTypeList: [
        { oliname: 'G7能源-充值子账户', value: '20' }
      ],
      startDatr: null,
      endDate: null,
      // AllData: {},
      isDisable: false,
      h: 500,
      dateFormatUtil: dateFormatUtil,
      dateTimeFormat: dateTimeFormat,
      dateFormat: dateFormat,
      emptyFn: emptyFn,
      dialogVisible: false,
      tableList: [],
      searchFrom: {
        pageNo: 1,
        pageSize: 50,
        trade_timeGS: null
      },
      total: 0,
      loading: false,
      goodTypes: [],
      btnFlg: [],
      btnIdArr: ['00JM140100', '00JM140200']
    }
  },
  created () {
    this.btnFlg = getBtn(this.btnIdArr, '/oilgasConsume')
    this.getList(this.searchFrom)
  },
  mounted () {
    let h = this.$refs.searchBox.offsetHeight
    let pH = document.documentElement.clientHeight
    this.h = (pH - h - 98) + 'px'
    function timestampToTime (time) {
      var date = new Date(time)// 时间戳为10位需*1000，时间戳为13位的话不需乘1000
      var Y = date.getFullYear() + '-'
      var M = (date.getMonth() + 1 < 10 ? '0' + (date.getMonth() + 1) : date.getMonth() + 1) + '-'
      var D = date.getDate() < 10 ? '0' + date.getDate() : date.getDate()
      return Y + M + D
    };
    // this.startDatr = timestampToTime(new Date().getTime() - 1000 * 60 * 60 * 24 * 30)
    this.trade_timeGe = timestampToTime(new Date().setTime(new Date(new Date().getFullYear(), new Date().getMonth(), 1)))
    this.trade_timeLe = timestampToTime(new Date().getTime())
    this.searchFrom.trade_timeGS = [this.trade_timeGe, this.trade_timeLe]
    // if (this.searchFrom.dateVal != null) {
    //   this.$set(this.searchFrom, 'trade_timeGe', this.searchFrom.dateVal[0])
    //   this.$set(this.searchFrom, 'trade_timeLe', this.searchFrom.dateVal[1])
    // } else {
    //   this.$set(this.searchFrom, 'trade_timeGe', null)
    //   this.$set(this.searchFrom, 'trade_timeLe', null)
    // }
    getG7CardExpenseTraderList(this.searchFrom).then(res => {
      this.loading = false
      this.tableList = res.result
      this.total = res.totalCount
    })
    // const start = new Date()
    // let shijian = dateFormatUtil('yyyy-MM-dd', start.setTime(new Date(new Date().getFullYear(), new Date().getMonth(), 1)))
    // console.log(shijian)
  },
  methods: {
    // statusFormat (row, column, cellValue) {
    //   switch (cellValue) {
    //     case '20':
    //       return '充值子账户'
    //   }
    // },
    // dateChange () {
    //   getG7CardExpenseTraderList(this.searchFrom).then(res => {
    //     this.loading = false
    //     this.tableList = res.list
    //     this.total = res.total
    //     // this.AllData.total = res.total
    //   })
    // },
    exportFn () {
      let form = { ...this.searchFrom }
      exportExcel(
        this.global.payServer + '/downstreamSettlement/exportG7CardExpenseTraderList',
        form,
        '油气消费记录'
      )
      this.isDisable = true
      setTimeout(() => {
        this.isDisable = false // 点击一次时隔两秒后才能再次点击
      }, 2000)
    },
    // 查选
    searchFn () {
      if (this.searchFrom.cargoBarcodes) { this.searchFrom.cargoBarcodes = this.searchFrom.cargoBarcodes.split(/[(\r\n)\r\n]+/) }
      this.getList(this.searchFrom)
    },
    // 选择数据
    selectGoods (selection) {

    },
    // 点击选中
    handleRowClick (row, column, event) {
      this.$refs.table.toggleRowSelection(row)
    },
    // 获取列表
    getList (searchFrom) {
      this.loading = true
      // if (this.searchFrom.dateVal != null) {
      //   this.$set(this.searchFrom, 'trade_timeGe', this.searchFrom.dateVal[0])
      //   this.$set(this.searchFrom, 'trade_timeLe', this.searchFrom.dateVal[1])
      // } else {
      //   this.$set(this.searchFrom, 'trade_timeGe', null)
      //   this.$set(this.searchFrom, 'trade_timeLe', null)
      // }
      getG7CardExpenseTraderList(searchFrom).then(res => {
        this.loading = false
        this.tableList = res.result
        this.total = res.totalCount
        // this.AllData.total = res.total
      })
    },
    // 每页条数
    handleSizeChange (val) {
      this.searchFrom.pageSize = val
      this.getList(this.searchFrom)
    },
    // 当前页
    handleCurrentChange (val) {
      this.searchFrom.pageNo = val
      this.getList(this.searchFrom)
    },
    // 重置
    resetForm (formName) {
      // debugger
      this.searchFrom = {
        pageNo: 1,
        pageSize: 50,
        trade_timeGS: [this.trade_timeGe, this.trade_timeLe]
      }
    }
  }
}
</script>

<style scoped lang='less'>
.searchBtnBox {
  margin-left: 10px;
}
.inpBox .el-date-editor{
  width: 350px!important;
}
</style>
